import { Card, ChoiceChips, ColumnChart, EmptyState } from '@platform/design-system';
import { useState, type ReactNode } from 'react';
import { usePageContext } from '../usePageContext.ts';
import { CHART_METRICS, chartPointsOf, type ChartMetric, type PerformanceReport } from './performance.ts';

export type TrendCardProps = {
  report: PerformanceReport | undefined;
  loading: boolean;
  emptyAction?: ReactNode;
};

export const TrendCard = ({ report, loading, emptyAction }: TrendCardProps) => {
  const { t, locale } = usePageContext();
  const [metric, setMetric] = useState<ChartMetric>('created');
  const metricName = t(`dashboard.${metric}`);
  return (
    <Card
      title={t('dashboard.seriesTitle')}
      actions={
        <ChoiceChips
          legend={t('dashboard.seriesTitle')}
          hideLegend
          locale={locale}
          value={metric}
          choices={CHART_METRICS.map((value) => ({ value, label: t(`dashboard.${value}`) }))}
          onChange={setMetric}
        />
      }
    >
      {report?.orders.created === 0 ? (
        <EmptyState
          title={t('dashboard.noOrdersTitle')}
          description={t('dashboard.noOrdersDescription')}
          action={emptyAction}
        />
      ) : (
        <ColumnChart
          label={t('dashboard.chartLabel', { metric: metricName })}
          points={report === undefined ? [] : chartPointsOf(report, metric, locale)}
          loading={loading}
        />
      )}
    </Card>
  );
};
